import React, {useEffect, useState} from 'react';
import {Outlet} from "react-router-dom";
import {AuthService} from "../../services/auth.service";
import useAppDispatch from "../../hooks/useAppDispatch";
import {login, logout} from "../../store/profile/profileSlice";
import Message from "../Message/Message";
import {GymSettingsService} from "../../services/gymSettings.service";
import {setGymSettings} from "../../store/gymSettings/gymSettingsSlice";
import LoginPopup from "../LoginPopop/LoginPopup";
import {SiteContentService} from "../../services/siteContent.service";
import {setSiteContent} from "../../store/siteContent/siteContentSlice";
import {useTranslation} from "react-i18next";
import useAppSelector from "../../hooks/useAppSelector";
import Spinner from "../Spiner/Spinner";
import {GeneralSettingsService} from "../../services/generalSettings.service";
import {setGeneralSettings} from "../../store/generalSettings/generalSettingsSlice";
import {getStripeKey} from "../../store/stripeKeys/ActionStripeKeys";
import {$clientApi} from "../../http";
import LocationGymPopup from "../LocationGymPopup/LocationGymPopup";
import {setActiveGym} from "../../store/multiGyms/multiGymsSlice";

function App() {

    const dispatch = useAppDispatch();
    const {i18n} = useTranslation();

    const {activeGym} = useAppSelector(state => state.multiGymsSlice);
    const {isAuthorized} = useAppSelector(state => state.profileSlice);
    const {contentLoading} = useAppSelector(state => state.siteContentSlice);
    const {gymSettings} = useAppSelector(state => state.gymSettingsSlice);
    const {generalSettings} = useAppSelector(state => state.generaContentSettingsSlice);
    const {loginPopup} = useAppSelector(state => state.notificationSlice);

    const [activeGymLoaded, setActiveGymLoaded] = useState(false);
    const [visibleLocationGymPopup, setVisibleLocationGymPopup] = useState(false);

    useEffect(() => {
        const activeGymFromLocal = localStorage.getItem("active_gym_info");
        if (!activeGymFromLocal) {
            AuthService.logout();
            dispatch(logout());
            setVisibleLocationGymPopup(true);
        } else {
            const activeGymObj = JSON.parse(activeGymFromLocal);
            dispatch(setActiveGym(activeGymObj));
            $clientApi.defaults.baseURL = activeGymObj.endpoint;
            setActiveGymLoaded(true);
        }
    }, []);

    useEffect(() => {
        if (activeGymLoaded) {
            getGymSettings();
        }
    }, [activeGymLoaded, activeGym]);

    useEffect(() => {
        if (activeGymLoaded) {
            getUserProfile();
            dispatch(getStripeKey());
        }
    }, [isAuthorized, activeGymLoaded, activeGym])

    useEffect(() => {
        if (activeGymLoaded) {
            const selectedLanguageByUser = localStorage.getItem("selectedLanguage");
            if (selectedLanguageByUser) {
                getSiteContent(selectedLanguageByUser);
                getGeneralSettings();
            } else {
                getGeneralSettings().then(res => {
                    if (res && res.defaultLanguage) {
                        getSiteContent(res.defaultLanguage);
                        i18n.changeLanguage(res.defaultLanguage);
                    } else {
                        getSiteContent("en");
                        i18n.changeLanguage("en");
                    }
                })
            }
        }
    }, [activeGymLoaded, activeGym]);

    useEffect(() => {
        if (activeGymLoaded) {
            if (gymSettings && gymSettings.officialTitle) {
                document.title = gymSettings.officialTitle;
            }
            if (generalSettings.faviconPath) {
                const faviconTag = document.getElementById("favicon") as HTMLLinkElement | null;
                if (faviconTag) {
                    faviconTag.href = generalSettings.faviconPath;
                }
            }
        }
    }, [gymSettings, generalSettings, activeGymLoaded, activeGym]);

    const getUserProfile = async () => {
        console.log(1);
        try {
            const response = await AuthService.getProfile();
            dispatch(login(response.data));
        } catch (e) {
            console.log(e);
            dispatch(logout());
            AuthService.logout();
        }
    }

    const getGymSettings = async () => {
        try {
            const response = await GymSettingsService.getGymSettings();
            if (response.data && response.status === 200) {
                dispatch(setGymSettings(response.data));
            }
        } catch (e) {
        }
    }

    const getSiteContent = async (language: string) => {
        try {
            const response = await SiteContentService.getSiteContent(language);
            if (response.data && response.status === 200) {
                dispatch(setSiteContent(response.data));
            }
        } catch (e) {
        }
    }

    const getGeneralSettings = async () => {
        try {
            const response = await GeneralSettingsService.getGeneralSettings();
            if (response.data && response.status === 200) {
                dispatch(setGeneralSettings(response.data));
                return response.data;
            }
        } catch (e) {
        }
    }

    const closeLocationGymPopup = async () => {
        setVisibleLocationGymPopup(false);
        setActiveGymLoaded(true);
    }

    if (visibleLocationGymPopup) {
        return (
            <LocationGymPopup
                fromApp={true}
                closePopupFn={closeLocationGymPopup}
            />
        )
    }

    if (contentLoading || !activeGymLoaded) {
        return (
            <div className={"spinner-wrapper"}>
                <Spinner/>
            </div>
        )
    }

    return (
        <>
            {loginPopup.isOpen && (
                <LoginPopup/>
            )}
            <Message/>
            <Outlet/>
        </>
    );
}

export default App;
